import { createStore, produce } from 'solid-js/store'

export type LogType = 'info' | 'success' | 'warning' | 'milestone' | 'danger'

export interface LogEntry {
  id: number
  message: string
  type: LogType
  time: number // game time in seconds
}

interface EventLogState {
  entries: LogEntry[]
  nextId: number
}

const MAX_ENTRIES = 50

const [logState, setLogState] = createStore<EventLogState>({
  entries: [],
  nextId: 1,
})

export const eventLog = {
  add: (message: string, type: LogType = 'info', gameTime: number = 0) => {
    setLogState(produce(s => {
      s.entries.unshift({
        id: s.nextId++,
        message,
        type,
        time: gameTime,
      })
      // Keep only last MAX_ENTRIES
      if (s.entries.length > MAX_ENTRIES) {
        s.entries = s.entries.slice(0, MAX_ENTRIES)
      }
    }))
  },

  clear: () => {
    setLogState({ entries: [], nextId: 1 })
  },

  get entries() {
    return logState.entries
  }
}

// Helper functions for common log types
export const log = {
  info: (msg: string, time?: number) => eventLog.add(msg, 'info', time),
  success: (msg: string, time?: number) => eventLog.add(msg, 'success', time),
  warning: (msg: string, time?: number) => eventLog.add(msg, 'warning', time),
  milestone: (msg: string, time?: number) => eventLog.add(msg, 'milestone', time),
  danger: (msg: string, time?: number) => eventLog.add(msg, 'danger', time),
}
